import React from 'react'
// import { Link } from 'react-router-dom';

import teamA from './Image/Teams/SHRACHI.webp';
import teamB from './Image/Teams/JSW.webp';
import teamC from './Image/Teams/Hyderabad.webp';
import teamD from './Image/Teams/Tamilnadu.webp';
import teamE from './Image/Teams/HIL.webp';
import teamF from './Image/Teams/Kalinga Lancer.webp';
import teamG from './Image/Teams/RoyalRanchi.webp';
import teamH from './Image/Teams/Delhi SG Pipers.webp';


const StandingTable = () => {
  const teams = [
  {
    name: "Vedanta Kalinga Lancers",
    logo: teamF,
    p: 7,
    w: 4,
    ws: 2,
    l: 1,
    ls: 0,
    gf: 16,
    ga: 8,
    gd: 8,
    pts: 16,
    recentForm: ["W", "W", "L", "W", "W"],
  },
  {
    name: "Ranchi Royals",
    logo: teamG,
    p: 7,
    w: 3,
    ws: 1,
    l: 2,
    ls: 1,
    gf: 25,
    ga: 18,
    gd: 7,
    pts: 12,
    recentForm: ["W", "L", "L", "W", "L"],
  },
  {
    name: "Hyderabad Toofans",
    logo: teamC,
    p: 7,
    w: 3,
    ws: 0,
    l: 2,
    ls: 2,
    gf: 17,
    ga: 11,
    gd: 6,
    pts: 11,
    recentForm: ["W", "W", "W", "L", "W"],
  },
  {
    name: "HIL GC",
    logo: teamE,
    p: 7,
    w: 3,
    ws: 0,
    l: 2,
    ls: 2,
    gf: 21,
    ga: 18,
    gd: 3,
    pts: 11,
    recentForm: ["L", "L", "L", "L", "L"],
  },
  {
    name: "JSW Soorma Hockey Club",
    logo: teamB,
    p: 7,
    w: 3,
    ws: 1,
    l: 3,
    ls: 0,
    gf: 16,
    ga: 14,
    gd: 2,
    pts: 11,
    recentForm: ["W", "W", "L", "W", "W"],
  },
  {
    name: "Accord Tamil Nadu Dragons",
    logo: teamD,
    p: 7,
    w: 1,
    ws: 3,
    l: 2,
    ls: 1,
    gf: 19,
    ga: 22,
    gd: -3,
    pts: 10,
    recentForm: ["W", "L", "L", "L", "W"],
  },
  {
    name: "Shrachi Bengal Tigers",
    logo: teamA,
    p: 7,
    w: 3,
    ws: 0,
    l: 4,
    ls: 0,
    gf: 16,
    ga: 24,
    gd: -8,
    pts: 9,
    recentForm: ["L", "L", "W", "L", "W"],
  },
  {
    name: "SG Pipers",
    logo: teamH,
    p: 7,
    w: 1,
    ws: 0,
    l: 5,
    ls: 1,
    gf: 14,
    ga: 29,
    gd: -15,
    pts: 4,
    recentForm: ["W", "L", "L", "L", "L"],
  },
];

  
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full shadow-md rounded-lg ">
        <thead className="bg-[#ffbd00] text-white text-center">
          <tr>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">Team</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">P</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">W</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">WS</th>  
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">L</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">LS</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">GF</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">GA</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">GD</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">PTS</th>
          </tr>
        </thead>
        <tbody>
          {teams.map((team, index) => (
            <tr key={index} className="even:bg-gray-50 ">
              <td className="md:py-2 py-1 md:px-4 px-1  text-gray-800 flex items-center justify-center ">
                <img src={team.logo} className='md:mr-2 w-12 h-auto rounded-full' alt={`${team.name} logo`} />
              </td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.p}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.w}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.ws}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.l}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.ls}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.gf}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.ga}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.gd}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.pts}</td>
            </tr>
          ))}
          
        </tbody>
        
      </table>
      <p className='pt-2 text-sm'>* P - Played, W - Win, WS - Win with Shootout , L - Loss, LS - Loss with Shootout, GF - Goals For, GA - Goals Against, GD - Goals Difference, Pts - Points</p>
    </div>
  );
};

const ResultTable = () => {
  return (
    <div className='mx-auto m-2 md:px-[13.25rem] mt-14'>
      <div className="w-full bg-white shadow-md rounded-lg py-4">
      <h1 className="text-center text-3xl font-bold my-2 mb-6 text-[#3b0067]">Standings </h1>
        <StandingTable />
      </div>
    </div>
    
  )
}

export default ResultTable